import { gql } from '@apollo/client';

import { TRAINING_MANUAL_FIELDS, TRAINING_MEMBER_FIELDS, TRAINING_TEMPLATE_FIELDS } from './queries';

/** PUBLIC (no auth) — the training token is the authorization. */
export const SET_TRAINING_MODULE_STATUS_MUTATION = gql`
    mutation SetTrainingModuleStatus($body: SetTrainingModuleStatusInput!) {
        setTrainingModuleStatus(body: $body) {
            ${TRAINING_MANUAL_FIELDS}
        }
    }
`;

/** PUBLIC (no auth) — the author name is derived server-side from the token. */
export const ADD_TRAINING_COMMENT_MUTATION = gql`
    mutation AddTrainingComment($body: AddTrainingCommentInput!) {
        addTrainingComment(body: $body) {
            ${TRAINING_MANUAL_FIELDS}
        }
    }
`;

/** Staff (@Auth) — save the draft; publishing is a separate explicit step. */
export const UPDATE_TRAINING_TEMPLATE_MUTATION = gql`
    mutation UpdateTrainingTemplate($definition: JSON!) {
        updateTrainingTemplate(definition: $definition) {
            ${TRAINING_TEMPLATE_FIELDS}
        }
    }
`;

/** Copies the draft to the published snapshot — every manual updates immediately. */
export const PUBLISH_TRAINING_TEMPLATE_MUTATION = gql`
    mutation PublishTrainingTemplate {
        publishTrainingTemplate {
            ${TRAINING_TEMPLATE_FIELDS}
        }
    }
`;

/** Staff (@Auth) — issue (and optionally email) a team member's manual link. */
export const SEND_TRAINING_MANUAL_MUTATION = gql`
    mutation SendTrainingManual($body: SendTrainingManualInput!) {
        sendTrainingManual(body: $body) {
            ${TRAINING_MEMBER_FIELDS}
        }
    }
`;

/** Revokes the old link (it 404s immediately) and returns a fresh one. */
export const REISSUE_TRAINING_LINK_MUTATION = gql`
    mutation ReissueTrainingLink($teamMemberId: String!) {
        reissueTrainingLink(teamMemberId: $teamMemberId) {
            ${TRAINING_MEMBER_FIELDS}
        }
    }
`;

export const REVOKE_TRAINING_LINK_MUTATION = gql`
    mutation RevokeTrainingLink($teamMemberId: String!) {
        revokeTrainingLink(teamMemberId: $teamMemberId) {
            ${TRAINING_MEMBER_FIELDS}
        }
    }
`;

/** Staff (@Auth) — reply on the two-way training thread from the CMS. */
export const STAFF_ADD_TRAINING_COMMENT_MUTATION = gql`
    mutation StaffAddTrainingComment($body: StaffAddTrainingCommentInput!) {
        staffAddTrainingComment(body: $body) {
            ${TRAINING_MANUAL_FIELDS}
        }
    }
`;

export const DELETE_TRAINING_COMMENT_MUTATION = gql`
    mutation DeleteTrainingComment($commentId: String!) {
        deleteTrainingComment(commentId: $commentId) {
            message
        }
    }
`;
